// if (navigator.serviceWorker) {
//   navigator.serviceWorker.register('/serviceworker.js', { scope: './' })
//     .then(function(reg) {
//       console.log('[Companion]', 'Service worker registered!');
//     });
// }

// Service Worker registration — disabled in development to avoid
// caching/offline-page interference while debugging.
// Enable in production/staging only.
if ("serviceWorker" in navigator && !window.location.hostname.match(/^(localhost|127\.0\.0\.1|dev\.local)$/i)) {
    if (navigator.serviceWorker.controller) {
        console.log("[PWA Builder] active service worker found, no need to register");
    } else {
        // Registra el serviceworker
        console.log ("[PWA Builder] Registering service worker for production");
        navigator.serviceWorker
            .register("/serviceworker.js", {
                scope: "./"
            })
            .then(function (reg) {
                console.log("[PWA Builder] Service worker has been registered for scope: " + reg.scope);
            });
    }
}